// API Configuration for Calmren
// Development: Local Express API on 4001 (proxied through Vite on 4000)
// Production: Relative path — most admin routes are local-only, prod proxy only serves
// public endpoints (contact, subscribe) via Cloudflare Pages _redirects.

export const API_BASE_URL = import.meta.env.PROD
  ? '' // Use relative path in production
  : 'http://localhost:4001' // Local development points to Express API

export default API_BASE_URL
